import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { ArrowLeft, Calendar, User, Tag, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Blog() {
  const { t } = useTranslation();

  const posts = [
    {
      title: "10 Tips for Selling Safely Online",
      excerpt: "Learn how to protect yourself and get the best price for your items with these essential safety tips...",
      author: "Marcus Johnson",
      date: "Jan 12, 2026",
      category: "Safety",
      image: "🛡️"
    },
    {
      title: "Introducing Verified Profiles",
      excerpt: "We're adding a new layer of trust to our community. Here's what the blue checkmark means for you...",
      author: "Sarah Miller",
      date: "Jan 05, 2026",
      category: "Product Update",
      image: "✅"
    },
    {
      title: "Community Spotlight: The Vintage Collector",
      excerpt: "Meet Tom, who turned his passion for retro gaming into a thriving side business on Listo...",
      author: "Elena Rodriguez",
      date: "Dec 28, 2025",
      category: "Community",
      image: "🎮"
    },
    {
      title: "Sustainability Report 2025",
      excerpt: "How buying used items contributed to reducing carbon emissions in our local communities...",
      author: "Alex Chen",
      date: "Dec 15, 2025",
      category: "Impact",
      image: "🌱"
    }
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <nav className="border-b border-border sticky top-0 z-50 bg-background/95 backdrop-blur">
        <div className="container flex items-center justify-between h-16">
          <Link href="/">
            <a className="text-2xl font-bold gradient-text">{t('common.appName')}</a>
          </Link>
          <div className="flex items-center gap-4">
            <Link href="/">
              <a className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <ArrowLeft className="w-4 h-4" />
                {t('common.back')}
              </a>
            </Link>
            <LanguageSwitcher />
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <section className="py-20 bg-muted/30">
          <div className="container text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              The Listo <span className="gradient-text">Blog</span>
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Stories, tips, and insights from the marketplace community.
            </p>
          </div>
        </section>

        <section className="py-16 container">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2">
            {posts.map((post, i) => (
              <article key={i} className="group border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300">
                <div className="bg-muted h-48 flex items-center justify-center text-6xl">
                  {post.image}
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 text-xs text-muted-foreground mb-3">
                    <span className="flex items-center gap-1 bg-secondary/10 text-secondary-foreground px-2 py-1 rounded-full">
                      <Tag className="w-3 h-3" /> {post.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" /> {post.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <User className="w-3 h-3" /> {post.author}
                    </span>
                  </div>
                  <h2 className="text-2xl font-bold mb-3 group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-muted-foreground mb-4">
                    {post.excerpt}
                  </p>
                  <Button variant="link" className="px-0">
                    Read Story <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="py-16 bg-primary/5">
          <div className="container text-center">
            <h2 className="text-2xl font-bold mb-4">Subscribe to our newsletter</h2>
            <p className="text-muted-foreground mb-6">Get the latest updates and safety tips delivered to your inbox.</p>
            <div className="flex max-w-md mx-auto gap-2">
              <input 
                type="email" 
                placeholder="Enter your email" 
                className="flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background"
              />
              <Button>Subscribe</Button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
